import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useGooglePlaces } from '@/hooks/useGooglePlaces';
import { Card, CardContent } from '@/components/ui/card';

interface GoogleReviewsProps {
  siteName: string;
  address: string;
  city: string;
  className?: string;
}

const GoogleReviews: React.FC<GoogleReviewsProps> = ({ siteName, address, city, className = '' }) => {
  const { data, loading, error } = useGooglePlaces({ siteName, address, city });

  if (loading || error || !data.reviews.length) {
    return null;
  }

  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <Star 
          key={i} 
          className={`w-4 h-4 ${i < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} 
        />
      );
    }
    return stars;
  };

  return (
    <div className={className}>
      <h3 className="text-xl font-semibold mb-4 text-foreground">Avis Google</h3>
      <div className="grid gap-4">
        {data.reviews.map((review, index) => (
          <Card key={index} className="border border-border">
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h4 className="font-medium text-foreground">{review.authorName}</h4>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="flex">
                      {renderStars(review.rating)}
                    </div>
                    <span className="text-sm text-muted-foreground">{review.relativeTime}</span>
                  </div>
                </div>
                <Quote className="w-5 h-5 text-muted-foreground flex-shrink-0" />
              </div>
              
              <p className="text-muted-foreground leading-relaxed">
                {review.text}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default GoogleReviews;